export const getThesaurusList = () => {
  return `
query thesaurusList($limit: Int, $offset: Int,$filters: DBFilterInput){
    values: thesaurusList(
    limit: $limit,
    offset: $offset,
    filters: $filters
  ) {

    nameFr
name
nameEn
      slug
namePlural
namePluralEn
unimarc
desk
instrument
groupPart
solist
deskGroup
id


children {
      nameFr
name
  slug
nameEn
namePlural
namePluralEn
unimarc
desk
instrument
groupPart
solist
deskGroup
id


      children {
        nameFr
name
        slug
nameEn
namePlural
namePluralEn
unimarc
desk
instrument
groupPart
solist
deskGroup
id


        children {
          nameFr
name
          slug
nameEn
namePlural
namePluralEn
unimarc
desk
instrument
groupPart
solist
deskGroup
id


          children {
            nameFr
name
            slug
nameEn
namePlural
namePluralEn
unimarc
desk
instrument
groupPart
solist
deskGroup
id


          }
        }
      }
    }
thesaurus_parent {
  instrument
groupPart
solist
deskGroup
id
desk
unimarc
nameFr
nameEn
  slug
namePlural
namePluralFr
namePluralEn
name

}
  }

  }`
}
